import { Link } from 'react-router-dom';

export default function RegionSwitcher() {
  return (
    <section className="bg-foreground-950 border-b border-foreground-800 px-4 md:px-8 py-5">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
        <span className="font-label uppercase tracking-[0.28em] text-[11px] text-background-300">Now covering</span>
        <div className="flex items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold uppercase tracking-wider text-sm px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-2-fill"></i></span>California
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 border border-background-400/60 text-background-100 hover:border-accent-500 hover:text-accent-400 font-label font-bold uppercase tracking-wider text-sm px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line"></i></span>Arizona
            <span className="text-[10px] tracking-[0.18em] text-background-400">Soon</span>
          </Link>
        </div>
      </div>
    </section>
  );
}